import * as path from "node:path";
import { buildSliceLibraryDirectoryPath } from "./buildSliceLibraryDirectoryPath.js";
import { pascalCase } from "./lib/pascalCase.js";
import { resolveSliceModel } from "./lib/resolveSliceModel.js";
const buildSliceDirectoryPath = async (args) => {
  const model = await resolveSliceModel(args);
  return path.join(buildSliceLibraryDirectoryPath(args), pascalCase(model.name));
};
export {
  buildSliceDirectoryPath
};
//# sourceMappingURL=buildSliceDirectoryPath.js.map
